import HeroSection from "./Section/HeroSection";
import PromoVideoCard from "./Section/PromoVideoCard";
import Roadmap from "./Section/Roadmap";
import Rules from "./Section/Rules";
import TargetAudience from "./Section/TargetAudience";
import FaqSection from "./Section/FaqSection";
import Registration from "./Section/Registration";
import Footer from "../../component/Footer";
export default function Landing() {
  return (
    <div className="bg-black">
      <HeroSection />
      <PromoVideoCard />
      <Roadmap />
      <TargetAudience />
      <FaqSection />
      <Registration />
      <Rules />
      <Footer />
    </div>
  );
}
